<div *ngIf="header" class="labeled-section-header">
  <h4 class="labeled-section-key">
    {{ header }}
  </h4>

  <span
    class="metadata"
    [ngSwitch]="!!metadataUrl"
    [attr.data-e2e-id]="metadataE2eId"
    (click)="onMetadataClick.emit()"
  >
    <ng-container *ngSwitchCase="true">
      <i2g-router-link
        class="metadata-link"
        [label]="metadata"
        [route]="metadataUrl"
        [trackingObject]="metadataTrackingObject"
        [trackingAction]="metadataTrackingAction"
        [trackingAdditionalProperties]="metadataTrackingAdditionalProperties"
      >
      </i2g-router-link>
    </ng-container>

    <ng-container *ngSwitchDefault>
      {{ metadata }}
    </ng-container>
  </span>
</div>

<div #content class="section-content">
  <ng-content></ng-content>
</div>

<ng-container *ngIf="content.childElementCount === 0">
  <ul class="sections-list">
    <li
      *ngFor="
        let labeledSectionItem of items;
        trackBy: trackByFn;
        let pos = index
      "
      class="sections-list-item"
    >
      <ng-container
        [ngTemplateOutlet]="template"
        [ngTemplateOutletContext]="{
          labeledSectionItem: labeledSectionItem,
          position: pos
        }"
      >
      </ng-container>
    </li>
  </ul>
</ng-container>
